import React from "react";
import LeadInformationTab from "./LeadInformationTab";
import ChannelHistoryTab from "./ChannelHistoryTab";
import MessagesTab from "./MessagesTab";
import TrailTab from "./TrailTab";
import TasksTab from "./TasksTab";
import { useParams } from "react-router-dom";
import AttachmentTab from "./AttachmentTab";
import QuotationList from "./QuotationList";
import { CIRCLEONE_USER } from "../../../constants";
// import OrderInvoiceTab from "./OrderInvoiceTab";
import "./TabbedPanel.scss";

interface IPROPS {
  tickets: any;
  refetch: any;
  taskData: any;
  refetchTask: any;
  isLoading: any;
  setLiftingTaskData: any;
  handleButtonClick: any;
  setConfirmationModalOpen: any;
  confirmationModalOpen: any;
  setLiftingObj: any;
  buttonClicked: any;
  scrollToTop: any;
  setPaneOpen: any;
  paneOpen: any;
  setIsStatusWonSelected: any;
  isStatusWonSelected: any;
  leadTrailData: any;
  refetchLeadTrail: any;
}

const TabbedPanel: React.FC<IPROPS> = ({
  tickets,
  refetch,
  setLiftingTaskData,
  taskData,
  refetchTask,
  isLoading,
  handleButtonClick,
  setConfirmationModalOpen,
  confirmationModalOpen,
  setLiftingObj,
  buttonClicked,
  scrollToTop,
  setPaneOpen,
  paneOpen,
  setIsStatusWonSelected,
  isStatusWonSelected,
  leadTrailData,
  refetchLeadTrail,
}) => {
  const params = useParams();
  const uuid = params.uuid;

  const checkForTenant = localStorage.getItem(CIRCLEONE_USER);

  const tabs = [
    { id: "LeadInformationTab", label: "Lead information" },
    { id: "ChannelHistoryTab", label: "Channel history", disabled: true },
    { id: "MessagesTab", label: "Messages" },
    { id: "TrailTab", label: "Trail" },
    { id: "TasksTab", label: "Tasks" },
    { id: "AttachmentTab", label: "Attachment" },
  ];

  if (
    checkForTenant === "stage" ||
    checkForTenant === "vecv" ||
    checkForTenant === "meta"
  ) {
    tabs.push({ id: "quotation", label: "Quotation" });
  }

  tabs.push({ id: "OrderInvoiceTab", label: "Order/Invoice" });

  return (
    <>
      <div className="">
        <div className="ticket-tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`ticket-tab 
                ${paneOpen === tab.id ? "active" : ""} 
                ${tab.disabled ? "disabled" : ""}
              `}
              onClick={() => !tab.disabled && setPaneOpen(tab.id)}
              disabled={tab.disabled}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="ticket-content-card">
        {paneOpen === "LeadInformationTab" ? (
          <LeadInformationTab
            ticket={tickets}
            refetch={refetch}
            uuid={uuid}
            handleButtonClick={handleButtonClick}
            setConfirmationModalOpen={setConfirmationModalOpen}
            confirmationModalOpen={confirmationModalOpen}
            setLiftingObj={setLiftingObj}
            buttonClicked={buttonClicked}
            scrollToTop={scrollToTop}
            setIsStatusWonSelected={setIsStatusWonSelected}
            isStatusWonSelected={isStatusWonSelected}
            refetchLeadTrail={refetchLeadTrail}
            setPaneOpen={setPaneOpen}
          />
        ) : paneOpen === "ChannelHistoryTab" ? (
          <ChannelHistoryTab />
        ) : paneOpen === "MessagesTab" ? (
          <MessagesTab
            notesData={tickets}
            fetchingNotes={refetch}
            refetchLeadTrail={refetchLeadTrail}
          />
        ) : paneOpen === "TrailTab" ? (
          <TrailTab leadTrailData={leadTrailData} />
        ) : paneOpen === "TasksTab" ? (
          <TasksTab tasks={tickets} setLiftingTaskData={setLiftingTaskData} />
        ) : paneOpen === "AttachmentTab" ? (
          <AttachmentTab
            ticket={tickets}
            refetch={refetch}
            uuid={uuid}
            refetchLeadTrail={refetchLeadTrail}
          />
        ) : paneOpen === "quotation" ? (
          <QuotationList setPaneOpen={setPaneOpen} ticket={tickets} />
        )  : (
          <>SomethingElse</>
        )}
      </div>
    </>
  );
};

export default TabbedPanel;